import { useCacheKey } from './useCacheKey';
import { useOptimizely } from './useOptimizely';
import type { Decisions } from '../types';

export function useDecisions(): Decisions;
export function useDecisions<F extends keyof Decisions>(flag: F): Decisions[F];
export function useDecisions<F extends keyof Decisions>(flag?: F) {
    const { context } = useOptimizely();
    const { cookies } = useCacheKey();

    const proxy = new Proxy<Decisions>(JSON.parse(cookies.get('x-petm-decisions') ?? '{}'), {
        get(target, prop, receiver) {
            if (typeof prop !== 'string') return;
            context?.decide(prop);

            const value = Reflect.get(target, prop, receiver);
            if (!value) return false;

            return value;
        },
    });

    if (!flag) return proxy;
    return proxy[flag];
}
